export default __webpack_public_path__ + "44c9a0170bb32d79dfe84bb5f247a27e.png";